import React, { useEffect, useState } from 'react';
import { PhoneOutlineSmall } from '@blueprint/icons';
import {
    trackCallAgentCTADesktop,
    trackCallAgentVariantReveal
} from '../AgentDetails.tracking';
import { Container, Overlay, StyledLink } from './AgentCallCTAVariant.styles';
import { ListingAnalyticsTaxonomy } from 'graphql.generated';

const CallAgentVariant = ({
    listingId,
    phone,
    taxonomy
}: {
    listingId: number;
    phone: string;
    taxonomy: Pick<ListingAnalyticsTaxonomy, 'section' | 'brandName'>;
}) => {
    const [isActivated, setActivated] = useState(false);

    const onClick = () => {
        setActivated(true);
        trackCallAgentVariantReveal({ listingId, taxonomy });
    };

    useEffect(() => {
        setActivated(false);
    }, [phone]);

    return (
        <Container>
            <StyledLink
                href={`tel:${phone}`}
                onClick={trackCallAgentCTADesktop}
            >
                <PhoneOutlineSmall /> {phone}
            </StyledLink>

            {!isActivated && (
                <Overlay aria-hidden>
                    <StyledLink as="span" href="" onClick={onClick}>
                        <PhoneOutlineSmall />
                        Call agent
                    </StyledLink>
                </Overlay>
            )}
        </Container>
    );
};

export default CallAgentVariant;
